import Button from 'components/button/Button';
import Card from 'components/card/Card';
import Icon from 'components/icon/Icon';
import styled from 'styled-components';

import { black, blue, white } from '../modules/colors';
import media from '../modules/media';
import { fonts, spacing } from '../modules/metrics';

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${fonts.xl}px;
  color: ${black};
  padding-bottom: ${spacing.md}px;
  ${(props) => props.extraSpacing && `margin-bottom: ${spacing.lg}px;`}
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${spacing.xl}px;
  width: 100%;

  > div {
    margin-bottom: ${spacing.xl}px;
  }

  ${media.desktop} {
    width: 100%;
    margin: 0;
  }
`;

export const Photos = styled.div`
  padding-bottom: ${spacing.sm}px;
`;

export const PhotosContent = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const RightColumn = styled.div`
  width: 500px;

  ${media.desktop} {
    width: 100%;
    margin-top: ${spacing.xl}px;
  }

  > div {
    margin-bottom: ${spacing.lg}px;
  }
`;

export const IconModal = styled(Icon)`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
`;

export const ModalImage = styled.img`
  display: block;
  max-width: 90%;
  max-height: 90%;
  margin: 0 auto;
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: center;
`;

export const ImageDescription = styled.div`
  background: ${white};
  color: ${black};
  opacity: 0.7;
  font-size: ${fonts.xl}px;
  margin: ${spacing.md}px;
  text-align: center;
`;

export const DescriptionCard = styled(Card)`
  color: ${black};
  padding: ${spacing.md}px ${spacing.lg}px;
  white-space: break-spaces;
  line-height: 22px;
`;

export const ServiceRequestExcerptCompanyList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 ${spacing.xl}px 0 0;
  width: 100%;

  > div {
    margin-bottom: ${spacing.lg}px;
  }

  ${media.desktop} {
    width: 100%;
    margin: 0;
  }
`;

export const ShowMoreButton = styled(Button)`
  margin: 0 auto;
`;

export const Link = styled.a`
  color: ${blue};
`;

export const RatingsBreakdown = styled.div`
  margin-bottom: ${spacing.xl}px;
`;

export const RatingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.sm}px ${spacing.lg}px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const RatingLabel = styled.div`
  font-size: ${fonts.sm}px;
  color: ${black};
`;

export const RatingValue = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.sm}px;
  font-size: ${fonts.sm}px;
  color: ${black};
  font-weight: 500;
`;

export const RatingCount = styled.span`
  font-size: ${fonts.xs}px;
  color: #999;
  font-weight: 400;
`;
